module.exports = __webpack_public_path__ + "img/scruffy.54a6faab.png";